export default {
  create: {
    title: 'Agregar',
    subtitle: 'Letrex',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Letrex',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Letrex',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Letrex',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Letrex Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    rows: {
      label: 'Filas:',
    },
    columns: {
      label: 'Columnas:',
    },
    level: {
      label: 'Nivel:',
      placeholder: 'Seleccione el nivel...',
    },
    generationMode: {
      label: 'Forma de generación:',
      placeholder: 'Seleccione la forma...',
      options: {
        simple: 'Simple',
        distribution: 'Distribución',
      },
    },
    wordLengthRange: {
      section: 'Distribución',
      min: {
        label: 'Tamaño mínimo',
        tooltip: 'Tamaño mínimo de las palabras generadas.',
      },
      max: {
        label: 'Tamaño máximo',
        tooltip: 'Tamaño máximo de las palabras generadas.',
      },
    },
    prioritizeQuality: {
      label: 'Priorizar calidad',
      tooltip:
        'Ejecuta intentos extra después de la generación principal para intentar mejorar el resultado. Puede tardar más.',
    },
    avoidSimilarWords: {
      label: 'Evitar palabras similares',
      tooltip:
        'El sistema evitará palabras con similitudes significativas con las ya presentes en la cuadrícula.',
    },
    wordsList: {
      label: 'Lista de palabras:',
      copyTooltip: 'Copiar lista al portapapeles',
    },
    grid: {
      cellLabel: 'Celda fila {row}, columna {col}',
    },
  },
  sidebar: {
    exportHint: 'Necesita guardar antes de exportar.',
    defaultFileName: 'letrex',
  },
  button: {
    generate: 'Generar juego',
  },
  alert: {
    gameSaved: '¡Juego guardado con éxito!',
    cleared: '¡Cuadrícula limpiada con éxito!',
    generated: '¡Letrex generado con éxito!',
    generateFailed: 'No fue posible generar el Letrex.',
    wordLengthRangeInvalid:
      'Informe un intervalo válido de tamaño de palabras (mín. ≤ máx.).',
    wordsListCopied: '¡Lista de palabras copiada!',
    wordsListCopyFailed: 'No fue posible copiar la lista de palabras.',
    sendSuccess: 'Enviado con éxito',
    sendError: 'Error al enviar. Inténtelo de nuevo.',
  },
};
